import '../../assets/css/footer.css';
import logo from '../../assets/img/logo.png';

export default function Footer() {
    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-content">
                    <div className="footer-section">
                        <div className="footer-logo">
                            <img src={logo} alt="Logo" className="footer-logo-image" />
                            <h3 className="footer-shop-name">Navo Sổ Tiệm</h3>
                        </div>
                        <p className="footer-description">
                            Phần mềm quản lý bán hàng, lịch hẹn, khách hàng và báo cáo dành cho salon, spa, cửa hàng
                            dịch vụ và nhiều ngành nghề khác. Vận hành trơn tru, tăng doanh thu, giảm thất thoát.
                        </p>
                    </div>
                    <div className="footer-section">
                        <h4 className="footer-title">Thông tin liên hệ</h4>
                        <div className="footer-contact">
                            <div className="footer-contact-item">
                                <i className="fa-solid fa-phone"></i>
                                <span>0886.299.670</span>
                            </div>
                            <div className="footer-contact-item">
                                <i className="fa-solid fa-envelope"></i>
                                <span>Navosotiem@gmail.com</span>
                            </div>
                            <div className="footer-contact-item">
                                <i className="fa-solid fa-location-dot"></i>
                                <span>Địa chỉ: HD Mon City, Nguyễn Cơ Thạch, Mỹ Đình 2, Hà Nội</span>
                            </div>
                            <div className="footer-contact-item">
                                <i className="fa-solid fa-globe"></i>
                                <a href="https://sotiem.vn/" target="_blank" rel="noopener noreferrer">
                                    sotiem.vn
                                </a>
                            </div>
                        </div>
                    </div>
                    <div className="footer-section">
                        <h4 className="footer-title">Giờ mở cửa</h4>
                        <div className="footer-hours">
                            <div className="footer-hours-text">
                                <div>Thứ 2 - Chủ nhật: 8:00 - 22:00</div>
                            </div>
                        </div>
                    </div>
                    <div className="footer-section">
                        <h4 className="footer-title">Theo dõi chúng tôi</h4>
                        <div className="footer-social">
                            <a href={'https://www.facebook.com/NAVOSotiemkinhdoanh'} target="_blank" rel="noopener noreferrer" className="footer-social-link" title="Facebook">
                                <i className="fab fa-facebook-f"></i>
                            </a>
                            <a href={'https://www.facebook.com/NAVOSotiemkinhdoanh'} target="_blank" rel="noopener noreferrer" className="footer-social-link" title="Messenger">
                                <i className="fab fa-facebook-messenger"></i>
                            </a>
                            <a href={'https://www.tiktok.com/@navosotiemkinhdoanh?lang=vi-VN'} target="_blank" rel="noopener noreferrer" className="footer-social-link" title="TikTok">
                                <i className="fab fa-tiktok"></i>
                            </a>
                            <a href={`mailto:${'navosotiem@gmail.com'}`} className="footer-social-link" title="Email">
                                <i className="fas fa-envelope"></i>
                            </a>
                            <a href={`tel:${'0886299670'}`} className="footer-social-link" title="Gọi điện">
                                <i className="fas fa-phone"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="footer-bottom">
                    <div className="footer-copyright">
                        <p>&copy; 2024 {'Quản lý tiệm thông minh'}. Tất cả quyền được bảo lưu.</p>
                    </div>
                    <div className="footer-links">
                        <a href="/" className="footer-link">Trang chủ</a>
                        <a href="/navo-admin/login" className="footer-link">Admin</a>
                    </div>
                </div>
            </div>
        </footer>
    );
}
